<template>
  <div class="scrap-goods-step-container">
    <ds-page-header :title="$t('scrapGoodsStep.page.title')" :subtitle="$t('scrapGoodsStep.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="handleGoBack">{{ $t('viewResourceMyGoodsInfo.back') }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleOpenSelectModal">
          {{ $t('viewResourceMyGoodsInfo.selectGoods') }}
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click="handleSubmit">
          {{ $t('scrapGoodsStep.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('viewResourceMyGoodsInfo.goodsInfo') }}</span>
        </template>
      </ds-toolbar>
      <ds-data-table :data="form.resourceStores" border
        :empty-description="$t('scrapGoodsStep.page.empty')">
        <el-table-column prop="resName" :label="$t('viewResourceMyGoodsInfo.goodsName')" align="center" min-width="140" />
        <el-table-column prop="resCode" :label="$t('viewResourceMyGoodsInfo.goodsCode')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resCode || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('viewResourceMyGoodsInfo.goodsType')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.parentRstName || '-' }} &gt; {{ scope.row.rstName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="isFixedName" :label="$t('viewResourceMyGoodsInfo.isFixedGoods')" align="center" width="110" />
        <el-table-column :label="$t('viewResourceMyGoodsInfo.goodsStock')" align="center" width="120">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.stock }}{{ scope.row.unitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('viewResourceMyGoodsInfo.miniStock')" align="center" width="130">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.miniStock }}{{ scope.row.miniUnitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('viewResourceMyGoodsInfo.lossQuantity')" align="center" min-width="170">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.giveQuantity" :min="0" :max="parseFloat(scope.row.miniStock)"
              :precision="2" controls-position="right" style="width: 120px" />
            {{ scope.row.miniUnitCodeName }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('viewResourceMyGoodsInfo.usageType')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.state" style="width: 100%">
              <el-option :label="$t('viewResourceMyGoodsInfo.selectUsageType')" value="" />
              <el-option :label="$t('viewResourceMyGoodsInfo.scrapRecycle')" value="1001" />
              <el-option :label="$t('viewResourceMyGoodsInfo.publicLoss')" value="3003" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="$t('viewResourceMyGoodsInfo.remark')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.purchaseRemark" :placeholder="$t('viewResourceMyGoodsInfo.requiredRemark')" clearable />
          </template>
        </el-table-column>
        <el-table-column :label="$t('viewResourceMyGoodsInfo.operation')" align="center" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="handleRemoveItem(scope.row.resId, scope.$index)">
              {{ $t('viewResourceMyGoodsInfo.remove') }}
            </el-button>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('scrapGoodsStep.lossDescription') }}</span>
      </div>
      <el-form :model="form" label-width="120px" class="ds-form">
        <el-form-item :label="$t('scrapGoodsStep.lossDescription')">
          <el-input type="textarea" v-model="form.remark" :placeholder="$t('scrapGoodsStep.requiredRemark')" :rows="2" />
        </el-form-item>
      </el-form>
    </div>

    <choose-resource-staff ref="chooseResourceStaff" @setSelectResourceStores="handleSetSelectedStores" />
  </div>
</template>

<script>
import { saveAllocationUserStorehouse } from '@/api/resource/scrapGoodsStepApi'
import { getCommunityId } from '@/api/community/communityApi'
import ChooseResourceStaff from '@/components/resource/chooseResourceStaff'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'ScrapGoodsStepList',
  components: {
    ChooseResourceStaff,
    DsPageHeader,
    DsToolbar,
    DsDataTable
  },
  data() {
    return {
      form: {
        resourceStores: [],
        remark: '',
        communityId: '',
        acceptUserId: '',
        acceptUserName: '',
        flag: '1'
      }
    }
  },
  created() {
    this.form.communityId = getCommunityId()
  },
  methods: {
    handleGoBack() {
      this.$router.go(-1)
    },
    handleNotify(goodsInfo) {
      this.form.resourceStores = goodsInfo
    },
    handleOpenSelectModal() {
      this.$refs.chooseResourceStaff.open()
    },
    handleSetSelectedStores(resourceStores) {
      this.form.resourceStores = resourceStores.map(item => {
        return {
          ...item,
          state: '',
          purchaseRemark: '',
          giveQuantity: 0
        }
      })
    },
    handleRemoveItem(resId, index) {
      this.form.resourceStores.splice(index, 1)
      this.$refs.chooseResourceStaff.removeSelectedItem(resId)
    },
    handleSubmit() {
      if (this.form.resourceStores.length === 0) {
        this.$message.error(this.$t('scrapGoodsStep.selectGoodsFirst'))
        return
      }
      if (!this.form.remark) {
        this.$message.error(this.$t('scrapGoodsStep.requiredRemark'))
        return
      }
      for (const item of this.form.resourceStores) {
        if (!item.giveQuantity || parseFloat(item.giveQuantity) <= 0) {
          this.$message.error(this.$t('scrapGoodsStep.requiredQuantity'))
          return
        }
        if (parseFloat(item.giveQuantity) > parseFloat(item.miniStock)) {
          this.$message.error(`${item.resName} ${this.$t('scrapGoodsStep.stockNotEnough')}`)
          return
        }
        if (!item.state) {
          this.$message.error(this.$t('scrapGoodsStep.requiredUsageType'))
          return
        }
        if (!item.purchaseRemark) {
          this.$message.error(this.$t('scrapGoodsStep.requiredNote'))
          return
        }
      }
      saveAllocationUserStorehouse(this.form)
        .then(response => {
          if (response.code === 0) {
            this.$message.success(this.$t('common.operationSuccess'))
            this.$router.push('/resource/myResourceStoreManage')
          } else {
            this.$message.error(response.msg)
          }
        })
        .catch(error => {
          this.$message.error(this.$t('scrapGoodsStep.submitFailed'))
          console.error(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.scrap-goods-step-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-lg); }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-md);
    border-bottom: 1px solid var(--ds-gray-200);
  }
  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
.ds-form {
  margin-top: var(--ds-spacing-sm);
}
</style>
